import { z } from "zod";

export const schema = z.object({
  id: z.string(),
  teamId: z.string(),
  partnerId: z.string(),
});

export type PartnerTeam = z.infer<typeof schema>;

export const partnerTeamNewSchema = schema.omit({ id: true });
export type PartnerTeamNew = z.infer<typeof partnerTeamNewSchema>;
